import { IBaseNavRoute, INavRoute, Nav } from 'app/components'
import { initHighcharts } from 'app/containers/App/HighchartsInit'
import { AdminNavRoutes, LoggedInAppNavRoutes, LoggedOutAppNavRoutes } from 'app/containers/App/routes'
import { Container, IAppState } from 'app/containers/Container'
import { store } from 'app/redux/App/store'
import { UserActions } from 'app/redux/User/actions'
import * as React from 'react'
import { Provider } from 'react-redux'
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom'

interface IAppComponentState {
  isLoggedIn: boolean
  currentNavRoute: INavRoute[]
  defaultPath: string
  isInit: boolean
  noLeftNav: boolean
}

class App extends Container<{}, IAppComponentState> {
  state = {
    isLoggedIn: false,
    currentNavRoute: [],
    defaultPath: '/',
    isInit: false,
    noLeftNav: true
  }

  mapAppStateToContainerState(appState: IAppState) {
    const isInit = !!appState.User.isInit
    const noLeftNav = this.state.noLeftNav
    const isLoggedIn = !!appState.User.username
    let isAdmin = false
    if (appState.User.token != null && appState.User.token !== '') {
      const base64Url = appState.User.token.split('.')[1]
      const base64 = base64Url.replace('-', '+').replace('_', '/')
      const jsonUser = JSON.parse(window.atob(base64))
      isAdmin = jsonUser['cognito:groups'].includes('AdminUsers')
    }

    const currentNavRoute = isLoggedIn ? ((isAdmin) ? AdminNavRoutes : LoggedInAppNavRoutes) : LoggedOutAppNavRoutes
    const currentHash = location.hash.replace('#', '')
    const firstRoute = currentNavRoute[0]
    const defaultPath = firstRoute.single ? firstRoute.single.path : firstRoute.multi.routes[0].path

    return { isLoggedIn, currentNavRoute, defaultPath, isInit, noLeftNav }
  }

  componentDidMount() {
    UserActions.init()
  }

  render() {
    //Prevent route from being changed
    if (!this.state.isInit) {
      return null
    }

    let pageContainerClasses = 'page-container'

    if (this.state.noLeftNav) {
      pageContainerClasses += ' no-left-nav'
    }

    return (
      <Provider store={store} key="provider">
        <HashRouter>
          <section className={pageContainerClasses}>
            <Nav
              history={App.History}
              config={this.state.currentNavRoute}
              noLeftNav={this.state.noLeftNav} />

            <main className="page">
              <Switch>
                {this.state.currentNavRoute.map((route) =>
                  this.mapAppNavRoutesToReactRoutes(route)
                )}
                <Redirect to={this.state.defaultPath} />
              </Switch>
            </main>
          </section>
        </HashRouter>
      </Provider>
    )
  }
}

export {
  App
}



// WEBPACK FOOTER //
// ./src/app/containers/App/index.tsx